<button mat-icon-button color="warn" (click)="onClose()"><mat-icon>close</mat-icon></button>
<section class="video-player">
    <admin-media-asset-player [src]="src$ | async" [token]="token$ | async"> </admin-media-asset-player>
</section>
